import { ErrorMessage } from '@ardoq/error-boundary';
import { FlexBox } from '@ardoq/layout';
import { LoadDataErrorProps } from './PropTypes';

export const LoadDataError = ({ errorMessage }: LoadDataErrorProps) => (
  <FlexBox padding="small">
    <ErrorMessage title={errorMessage} />
  </FlexBox>
);
